<template>
    <div>
        <api-calls-line class="chart" v-if="this.activeChart === this.chartOptions[0]" :labels="this.labels" :dataClientApi="this.dataClientApi" :dataServiceApi="this.dataServiceApi"></api-calls-line>
        <api-calls-bar class="chart" v-if="this.activeChart === this.chartOptions[1]" :labels="this.labels" :dataClientApi="this.dataClientApi" :dataServiceApi="this.dataServiceApi"></api-calls-bar>
        <custom-input type="dropdown" class="dropdown" :items="this.chartOptions" :value="this.activeChart.value" @input="this.updateActiveChart"></custom-input>
    </div>
</template>

<script>
import customInput from '@/components/additional/customInput';
import apiCallsLine from '@/components/statistics/apiCalls/line';
import apiCallsBar from '@/components/statistics/apiCalls/bar';
import dateformat from 'dateformat';

export default {
    name: 'api-calls',
    components: {
        customInput,
        apiCallsLine,
        apiCallsBar
    },
    props: ['data'],
    data() {
        return {
            labels: [],
            dataClientApi: [],
            dataServiceApi: [],
            chartOptions: [
                {
                    label: 'Line',
                    value: 'line'
                },
                {
                    label: 'Bar',
                    value: 'bar'
                }
            ],
            activeChart: {}
        };
    },
    mounted() {
        this.activeChart = this.chartOptions[0];
        this.preRenderData(this.data);
    },
    watch: {
        data: function(newVal, oldVal) {
            this.preRenderData(this.data);
        }
    },
    methods: {
        preRenderData: function(data) {
            data.forEach((item) => {
                switch (item.api) {
                    case 'clientApi':
                        this.dataClientApi.push(item.count ? item.count : 0);
                        break;
                    case 'serviceApi':
                        this.dataServiceApi.push(item.count ? item.count : 0);
                        break;
                }

                const date = new Date(item.hours);
                this.labels.push(dateformat(date, 'hh:MM:ss'));
            });
        },
        updateActiveChart: function(newChart) {
            if (newChart === this.chartOptions[0].value) // Line
                this.activeChart = this.chartOptions[0];
            else if (newChart === this.chartOptions[1].value) // Bar
                this.activeChart = this.chartOptions[1];
        }
    }
};
</script>

<style lang="scss" scoped>
    .custom-input {
        position: absolute;
        top: 0;
        right: 0;
        padding: 1em;
    }

    .chart {
        max-height: 100%;
        max-width: 100%;
    }
</style>